import { MD5, AES, enc } from "crypto-js";

const secret = process.env.REACT_APP_SECRET;

const tokenNameEncrypted = MD5(process.env.REACT_APP_NAME_TOKEN);

const userNameEncrypted = MD5(process.env.REACT_APP_NAME_USER);

const authenticateNameEncrypted = MD5(process.env.REACT_APP_NAME_LOGGED);

export const isAuthenticated = () => {
  const authenticateEncrypted =
    localStorage.getItem(authenticateNameEncrypted) ||
    AES.encrypt("false", secret).toString();

  const authenticateBytes = AES.decrypt(authenticateEncrypted, secret);

  const authenticateString = authenticateBytes.toString(enc.Utf8);

  const isAuthenticated = authenticateString === "true";

  return isAuthenticated;
};

export const setAuthenticated = (authenticated) => {
  localStorage.setItem(
    authenticateNameEncrypted,
    AES.encrypt(authenticated.toString(), secret).toString()
  );
};

export const getToken = () => {
  const tokenEncrypted =
    localStorage.getItem(tokenNameEncrypted) ||
    AES.encrypt("", secret).toString();

  const tokenBytes = AES.decrypt(tokenEncrypted, secret);

  const tokenString = tokenBytes.toString(enc.Utf8);

  return tokenString;
};

export const setToken = (token) => {
  localStorage.setItem(
    tokenNameEncrypted,
    AES.encrypt(token, secret).toString()
  );
};

export const getUser = () => {
  const userEncrypted =
    localStorage.getItem(userNameEncrypted) ||
    AES.encrypt(JSON.stringify({}), secret).toString();

  const userBytes = AES.decrypt(userEncrypted, secret);

  const userString = userBytes.toString(enc.Utf8);

  return JSON.parse(userString);
};

export const setUser = (user) => {
  localStorage.setItem(
    userNameEncrypted,
    AES.encrypt(JSON.stringify(user), secret).toString()
  );
};
